import React from "react";
import Logo3D from "../assets/logo-main.png";
import { footer, site } from "../content/home";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative mt-12 border-t border-black/10 bg-white/60 dark:border-white/10 dark:bg-ink-900/60">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-500/40 to-transparent" />
      <div className="mx-auto max-w-7xl container-px py-10">
        <div className="flex flex-col items-start gap-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <img
              src={Logo3D}
              alt={site.owner}
              className="h-10 w-10 rounded-xl object-cover ring-1 ring-black/10 dark:ring-white/15"
            />
            <div>
              <div className="font-display text-sm font-semibold text-gray-900 dark:text-white">{site.owner}</div>
              <div className="text-xs text-gray-600 dark:text-white/55">{footer.tagline}</div>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-gray-700 dark:text-white/70">
            {footer.links.map((l, i) => (
              <React.Fragment key={l.href}>
                {i > 0 && <span className="h-1 w-1 rounded-full bg-gray-300 dark:bg-white/20" />}
                <a className="hover:text-gray-900 dark:hover:text-white" href={l.href} target={l.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer">{l.label}</a>
              </React.Fragment>
            ))}
          </div>
        </div>
        <div className="mt-8 flex justify-center border-t border-black/5 pt-6 text-center text-xs text-gray-600 dark:border-white/5 dark:text-white/50">
          <span>© {year} {footer.copyrightHolder}. {footer.copyrightRights}.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;